import { DataBean } from "../DataBean";

export class TaxHoldValue extends DataBean {



    public async getTaxHoldValueByEmployee(employeeID:any,type:any,year:any,month:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTaxHoldValueByEmployee_Number_Number_Number_Number", [employeeID,type,year,month]);
    }
    
}